<template>
  <div class="progress-bar">
    <div :class="currentFileIcon"></div>
    <div class="progress-bar-body">
      <div class="progress-title">{{ props.title }}</div>
      <div class="progress-bar-container">
        <div class="progress-bar-inner" :style="{ width: props.percentage + '%' }"></div>
      </div>
      <div class="progress-text">{{ props.text }}</div>
    </div>
  </div>
</template>

<script setup >
  import { computed } from 'vue';
  const props = defineProps({
    icon: String,
    title: String,
    text: String,
    percentage: Number,
  });

  const currentFileIcon = computed(() => {
    const cls = 'progress-bar-icon'
    return cls + ' ' + props.icon
  });

</script>

<style lang="scss" scoped>
@import '@/mixins/style.scss';

.folder {
  background-image: url('@/assets/filetype/folder.png');
  background-size: 100%;
}

.progress-bar {
  display: flex;
  align-items: center;
  gap: 12px;
}
.progress-bar-icon {
  width: 32px;
  height: 32px;
  padding: 0px 0.2px 0.2px 0px;
  box-sizing: border-box;
}
.progress-bar-body {
  width: 388px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
  flex: 1 0 0;
}

.progress-title {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  align-self: stretch;
  overflow: hidden;
  color: var(--Color-Font-color_font_tier1, #2E3032);
  text-overflow: ellipsis;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.progress-bar-container {
  height: 4px;
  border-radius: 2px;
  background: #E2E4E6;
  align-self: stretch;
}

.progress-bar-inner {
  height: 100%;
  border-radius: 2px;
  background: var(--d-theme-main-color);
  transition: width 0.3s ease;
}

.progress-text {
  color: var(--Color-Font-color_font_tier2, #7E8082);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}

@media (max-width: 624px) {
  .progress-bar {
    width: 100%;
    .progress-bar-body {
      width: 100%;
    }
  }
}

</style>
